import { useEffect } from 'react';

export default function useFlowbite() {
	useEffect(() => {
		import('flowbite').then((module) => module.initFlowbite());
	}, []);
}
